import { Modal } from '../Modal';
import { Button } from '../Button';
import { ButtonWrapper } from './UserExistModal.parts';

type Props = {
  errorText: string;
  isOpen: boolean;
  closeModals: () => void;
};

export const UserExistModal = ({ isOpen, closeModals, errorText }: Props) => {
  return (
    <Modal width={'930px'} isOpen={isOpen} closeModal={closeModals} title={'Account Exists'}>
      <h3 style={{ textAlign: 'center' }}>{errorText}</h3>
      <ButtonWrapper>
        <Button onClick={() => window.location.assign('https://account.wonkybox.nz')}>Go to login</Button>
      </ButtonWrapper>
    </Modal>
  );
};
